import styled from 'styled-components';

export const SpinCont = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  top: 3px;

  ${({ theme }) => `
    padding: 0 ${theme.layout.spacing.mili};

    .ant-spin-dot-item {
      background: ${theme.colors.secondary[100]};
    }
  `};
`;
